import { JigConst } from '@/constants'

export default {
  jigPassword(state: any): string {
    return state.jigMetadata.Password || ''
  },
  jigVisibility(state: any): JigConst.JigVisibilities {
    return state.jigMetadata.ProjectVisibility
  },
}
